(function() {
  'use strict';

  const DEFAULT_EQUILIBRIO = 5;
  const DEFAULT_ALTO_EQUILIBRIO = 10;
  const DEFAULT_CONTROLE = 15;
  const DEFAULT_EXTREMO = 20;
  const DEFAULT_FAIXAS = [DEFAULT_EQUILIBRIO, DEFAULT_ALTO_EQUILIBRIO];
  const DEFAULT_CSS_CLASSES = ['bg-equilibrio', 'bg-controle', 'bg-alerta'];
  const CSS_CLASSES = ['bg-equilibrio', 'bg-alto_equilibrio', 'bg-controle', 'bg-alerta', 'bg-extremo'];

  angular
    .module('webAgro1App')
    .controller('IndicadorFaixasCtrl', IndicadorFaixasController);

  IndicadorFaixasController.$inject = [
    '$scope',
    '$timeout'
  ];
  // eslint-disable-next-line max-lines-per-function
  function IndicadorFaixasController($scope, $timeout) {
    const vm = this;
    vm.indicador = {};

    vm.faixasIndicadores = faixasIndicadores;
    vm.onSliderCreated = onSliderCreated;
    vm.faixaClass = faixaClass;

    function faixasIndicadores() {
      vm.showFaixas = false;
      switch (vm.indicador.numero_faixas) {
      case 3:
        vm.indicador.faixas = DEFAULT_FAIXAS;
        break;
      case 4:
        vm.indicador.faixas = [...DEFAULT_FAIXAS, DEFAULT_EXTREMO];
        break;
      case 5:
        vm.indicador.faixas = [...DEFAULT_FAIXAS, DEFAULT_CONTROLE, DEFAULT_EXTREMO];
        break;
      default:
        vm.indicador.faixas = [];
      }

      $timeout(() => {
        vm.showFaixas = true;
      });
    }

    function onSliderCreated(slider) {
      if (vm.numeroFaixas >=3 && vm.numeroFaixas <= 5) {
        const connect = slider.target.querySelectorAll('.noUi-connect');
        vm.css = DEFAULT_CSS_CLASSES;
        if (vm.indicador.numero_faixas > 3) {
          vm.css = CSS_CLASSES;
        }
        for (let i = 0; i < (vm.numeroFaixas); i++) {
          connect[i].classList.add(vm.css[i]);
        }
      }
    }

    function faixaClass() {
      return `faixa-${vm.numeroFaixas}`;
    }

    vm.$onInit = function() {
      vm.numeroFaixas = vm.indicador.numero_faixas || 3;
      vm.optionsWithoutStart = {
        connect: new Array(vm.numeroFaixas).fill(true),
        step: 1,
        range: {
          min: 0,
          max: 100
        }
      };

      if (!vm.indicador.numero_faixas) {
        vm.faixasIndicadores();
      }
    };

    $scope.$parent.$watch('indicador.numero_faixas', function(newValue, oldValue) {
      vm.numeroFaixas = vm.indicador.numero_faixas || 3;
      vm.optionsWithoutStart.connect = new Array(vm.numeroFaixas).fill(true);
      if (newValue !== oldValue && newValue) {
        vm.faixasIndicadores();
      } else {
        vm.showFaixas = true;
      }
    });
  }
}());
